<template>
  <div class="center">
    <div class="waitingcom_title">
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="目录名称：" prop="dayNum">
          <el-input
            v-model.trim="formLabelAlign.dayNum"
            placeholder="请输入目录名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="添加时间：" prop="examBeginDate">
          <div class="block">
            <el-date-picker
              v-model="formLabelAlign.examBeginDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button type="primary" icon="el-icon-search" class="searchbtn"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <div class="opera_btn">
      <el-button @click="encryption">
        <i class="iconfont icon-jiami"></i>试题保护(已开启)
      </el-button>
    </div>
    <div class="mian_view">
      <p>
        超级管理员“{{
          protect.CryptoRealName
        }}”已经开启试题保护，点击上方试题保护按钮可进行解密
      </p>
    </div>
  </div>
</template>

<script>
import { checkIsCrypto } from "@/api/quebankmana.js";
import loginvuex from "@/store/index";
import Pup from "./Pup.vue";
export default {
  data() {
    return {
      formLabelAlign: {
        dayNum: "",
        examBeginDate: "", //开通时间
      },
      dialogVisibleObj: {
        everywhere: false,
      },
      passwordForm: {
        userPaw: "",
      },
      labelPosition: "right",
      protect: {},
      isrules: {
        userPaw: [{ validator: protectPass(this), trigger: "blur" }],
      },
    };
  },
  methods: {
    async protectList() {
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await checkIsCrypto(res);
      if (Data.status === 200) {
        this.protect = Data.data.Data;
      }
      console.log(Data.data.Data);
    },
    async encryption() {
      this.$refs.popup.dialogVisibleObj.everywhere = true;
      // 密码加密
    },
  },
  async created() {
    await this.protectList();
  },
};
</script>

<style lang="scss" scoped>
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
}
.el-form {
  display: flex;
  ::v-deep .el-input > .el-input__inner {
    width: 200px;
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
.opera_btn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    margin-right: 24px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button {
    background: #ee6717;
  }
}
.mian_view {
  min-height: 640px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  p {
    font-size: 20px;
    color: #333333;
    margin-top: 50px;
    font-family: PingFang SC;
    font-weight: 400;
  }
}
.protect_the {
  ::v-deep .el-dialog {
    width: 626px !important;
    height: 362px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    line-height: 18px !important;
  }
  .mian {
    padding: 0px 24px;
    p:nth-child(1) {
      height: 84px;
      line-height: 84px;
      font-size: 15px;
      color: #333333;
    }
    p:nth-child(3) {
      font-size: 15px;
      margin-top: 20px;
      color: #999999;
    }
    ::v-deep .el-form-item__content {
      margin: 0px !important;
    }
    ::v-deep .el-input__inner {
      width: 380px;
      height: 50px;
    }
  }
  ::v-deep .el-input__suffix {
    right: 214px !important;
  }
  ::v-deep .el-input .el-input__clear {
    font-size: 18px;
  }
}
</style>